export default "__VITE_ASSET__DWX1weQ3__"